import { Dialog, DialogContent } from '@mui/material';
import { ReactNode } from 'react';
import { IconType } from 'react-icons';
import { BsInfoSquareFill } from 'react-icons/bs';
import { FaTimes } from 'react-icons/fa';
import { useIsAtOrNarrowerThan } from '~/shared/utils/useBreakpoint';
import { getLcn } from '~/utils/labeled-classnames';

export default function SimpleDialog({
  open,
  onClose,
  children,
}: {
  open: boolean
  onClose: () => void // or can't close by clicking away
  children: string | ReactNode
}) {

  const isXs = useIsAtOrNarrowerThan('xs')
  const lcn = getLcn({
    closeIcon: 'absolute top-2 right-2 opacity-40 hover:opacity-100',
  });

  return (
    <Dialog
      fullScreen={isXs}
      onClose={onClose}
      open={open}
      disableScrollLock={true}
    >
      <button className={lcn.closeIcon}>
        <FaTimes size={15} onClick={onClose} />
      </button>

      {/* <DialogTitle>Add later when needed</DialogTitle> */}
      <DialogContent className='flex flex-col gap-8 '>
        {children}
      </DialogContent>
    </Dialog>

  );
}; 